// Scroll maths from the design: clamp to 0–1, a 0 → 1 ramp between two points
// of progress, a straight blend, an ease-out curve and an ease-in-out
// (smoothstep) curve.
export const clamp = (x) => Math.min(1, Math.max(0, x))
export const ramp = (p, a, b) => clamp((p - a) / (b - a))
export const lerp = (a, b, t) => a + (b - a) * t
export const ease = (t) => 1 - (1 - t) ** 3
export const smooth = (t) => t * t * (3 - 2 * t)

// How far behind the scroll the pinned sections glide, in ms per smoothing
// stage (see useScrollDriver): they settle about half a second after the
// scroll stops.
export const GLIDE = 115

/** For a section whose sticky stage plays out over its extra height. */
export const stickyProgress = (el) => {
  const run = el.offsetHeight - window.innerHeight
  return run > 0 ? -el.getBoundingClientRect().top / run : 0
}
